import { ICommonData } from '../../../StepperStateCards/stepperStateCards.models';
import { useCoverageToolModalProvider } from '../../coverageToolModal.context';
import {
  CONSUMER_CMS_DEFAULT,
  ICoverageToolCongifg,
  useCmsConfig,
} from '@vfit/consumer/data-access';
import { API, trackView } from '@vfit/shared/data-access';
import { IEditAddressCmsConfig } from '@vfit/shared/models';
import { organizeEditAddressManual } from '@vfit/consumer/components';
import { ICoverageToolType, IInputs } from '../../coverageToolModal.models';
import CoverageToolManualTagging from './coverageToolManualCard.tagging';
import {
  CoverageToolContainer,
  CoverageToolContent,
  ManualContainer,
  Title,
} from '../../coverageToolModal.style';
import { CustomText } from '@vfit/shared/atoms';
import { fonts } from '@vfit/shared/themes';
import AddressManual from './components/AddressManual/addressManual';
import { useEffect } from 'react';

const CoverageToolManualCard = ({ handleGoNextSlide }: ICommonData) => {
  const { address, isForcedManual, setAddress, setIsAddressConfirmed, setIsSuccess, setIsError } =
    useCoverageToolModalProvider();
  const coverageToolConfig = useCmsConfig(
    CONSUMER_CMS_DEFAULT,
    API.CMS_GET_COVERAGE_TOOL_CONFIG
  ) as ICoverageToolCongifg;

  const handleTrackError = (fieldName: string) => {
    trackView({
      event_name: 'tool_error',
      event_label_track: 'error',
      event_category: `${fieldName} field not found`,
    });
  };

  const editManualFixed = useCmsConfig(
    CONSUMER_CMS_DEFAULT,
    API.CMS_GET_EDIT_ADDRESS
  ) as IEditAddressCmsConfig;

  const cmsConfig = organizeEditAddressManual(editManualFixed);

  const forceManualSubmit = (googleAddress: IInputs) => {
    const manualAddress = {
      ...googleAddress,
      latitude: parseFloat(googleAddress?.latitude?.toString() || ''),
      longitude: parseFloat(googleAddress?.longitude?.toString() || ''),
    };
    const coverageType = ICoverageToolType.MAPS;
    setAddress({
      ...manualAddress,
      typeCoverage: coverageType,
    });
    handleGoNextSlide?.();
  };

  useEffect(() => {
    setIsAddressConfirmed(false);
    setIsSuccess(false);
    setIsError(false);
  }, []);

  return (
    <>
      <CoverageToolManualTagging />
      <CoverageToolContainer>
        <CoverageToolContent>
          <Title>{coverageToolConfig.coveragetool.addressInput.title}</Title>
          <CustomText
            text={
              isForcedManual
                ? coverageToolConfig.coveragetool.manualInput.description
                : coverageToolConfig.coveragetool.manualInput.descriptionOnError
            }
            textAlign="center"
            size={20}
            lineHeight={26}
            fontFamily={fonts.regular}
            modal
          />
        </CoverageToolContent>
        <ManualContainer>
          <AddressManual
            state={address}
            onSubmit={(googleAddress) => forceManualSubmit(googleAddress)}
            cmsConfig={cmsConfig}
            handleTrackError={handleTrackError}
          />
        </ManualContainer>
      </CoverageToolContainer>
    </>
  );
};

export default CoverageToolManualCard;

